export const toLocaleNumber = (number, options) => (
  number.toLocaleString('nb-no', options)
);
